import state from "./moduleCampusState";
import mutations from "./moduleCampusMutations";
import actions from "./moduleCampusActions";
import getters from "./moduleCampusGetters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
